import React from 'react'
import './style.css'

const Start = () => {
  return (
    <div className='get' id='get'>
        <div className='start'>
            <h1>Get Started With Us</h1>
            <p>Subscribe and find super attractive price quotes from us</p>
            <button>Get Started</button>
        </div>
    </div>
  )
}

export default Start